import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { ShipToHome, Calendar, Delivery } from '@one-thd/sui-icons';
import { goBackToChangeForm, goBackToDeliveryDetails, } from '../../../../utils/edit-delivery-address/editDeliveryAddressUtils';
export var newDeliveryAddressBODFS = function (newDeliveryAddressDetails, deliveryInstructions, requireSignature, deliveryDate, suspendCartCheck, setSubmitCreateForm, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "sui-grid sui-grid-cols-[auto_1fr_auto] sui-gap-4" },
        React.createElement("div", null,
            React.createElement(ShipToHome, null)),
        React.createElement("div", null,
            React.createElement(Typography, { variant: "h5" }, "Delivery Address"),
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
                    React.createElement(Typography, null,
                        newDeliveryAddressDetails.firstName,
                        ' ',
                        newDeliveryAddressDetails.lastName)),
                React.createElement(Typography, null, newDeliveryAddressDetails.addressLine1),
                newDeliveryAddressDetails.addressLine2 && (React.createElement(Typography, null, newDeliveryAddressDetails.addressLine2)),
                React.createElement(Typography, null,
                    [newDeliveryAddressDetails.city, newDeliveryAddressDetails.state]
                        .filter(function (item) { return item === null || item === void 0 ? void 0 : item.trim(); })
                        .join(', '),
                    ' ',
                    newDeliveryAddressDetails.zipCode),
                React.createElement(Typography, null, newDeliveryAddressDetails.phoneNumber))),
        React.createElement("div", null,
            React.createElement(Button, { variant: "tertiary", fullWidth: true, onClick: function () {
                    return goBackToChangeForm(suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails);
                } }, "Edit"))),
    React.createElement("div", { className: "sui-grid sui-grid-cols-[auto_1fr_auto] sui-gap-4" },
        React.createElement("div", null,
            React.createElement(Calendar, null)),
        React.createElement("div", null,
            React.createElement(Typography, { variant: "h5" }, "Scheduled for"),
            React.createElement(Typography, null, deliveryDate),
            React.createElement(Typography, null, "All-Day Delivery Window"),
            React.createElement(Typography, null, "(6AM-8PM)"),
            React.createElement(Typography, null, requireSignature ? 'Signature Required' : 'No Signature Required')),
        React.createElement("div", null,
            React.createElement(Button, { variant: "tertiary", fullWidth: true, onClick: function () {
                    return goBackToDeliveryDetails(suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails);
                } }, "Edit"))),
    React.createElement("div", { className: "sui-grid sui-grid-cols-[auto_1fr_auto] sui-gap-4" },
        React.createElement("div", null,
            React.createElement(Delivery, null)),
        React.createElement("div", null,
            React.createElement(Typography, { variant: "h5" }, "Delivery Instructions"),
            React.createElement(Typography, null, deliveryInstructions || 'None')),
        React.createElement("div", null,
            React.createElement(Button, { variant: "tertiary", fullWidth: true, onClick: function () {
                    return goBackToDeliveryDetails(suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails);
                } }, "Edit"))))); };
